import ContactAppointmentPage from "@/app/contact/appointment.page";
import ContactPropertiesPage from "@/app/contact/contact-properties.page";
import { CONTACT_PROPERTIES_PATH, CONTACT_PROPERTIES_TITLE } from "@/lib/property-contact-scope";

export const contact_properties_routes = [
  {
    path: CONTACT_PROPERTIES_PATH,
    element: <ContactPropertiesPage />,
  },
  {
    path: `${CONTACT_PROPERTIES_PATH}/appointments/:appointmentId`,
    element: <ContactAppointmentPage back={{ name: CONTACT_PROPERTIES_TITLE, href: CONTACT_PROPERTIES_PATH }} />,
  },
];
